// extracted by mini-css-extract-plugin
module.exports = {"card":"playerModal_card__1PTHU","modalCardHeader":"playerModal_modalCardHeader__gJMdn","closeButton":"playerModal_closeButton__c2HGI","content":"playerModal_content__LOpZD"};